import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
} from "@material-ui/core";
import { ChangeMeta } from "@ofqual/portal-core/core/types";
import { Select } from "@ofqual/portal-components/components/Select";
import { AppBarButton } from "@ofqual/portal-components/components/SecondaryAppBar";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import React, { useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { RejectApplication } from "../../../domain/RejectApplication";
import { rejectApplication } from "../../../redux/actions";
import { applicationRejectReasonService } from "../../../services";
import { Error } from "../../common/Error";
import {
  buildMetaData,
  getLookupTracker,
} from "@ofqual/portal-core/core/utils/modelHelpers";

type RejectButtonAndDialogProps = {
  orgId: string;
  applicationId: string;
};

export const RejectButtonAndDialog: React.FC<RejectButtonAndDialogProps> = (
  props
) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <AppBarButton data-test="reject-button" text="Reject" onClick={() => setIsOpen(true)} />
      {isOpen && <RejectDialog {...props} onClose={() => setIsOpen(false)} />}
    </>
  );
};

type RejectDialogProps = {
  orgId: string;
  applicationId: string;
  onClose: () => void;
};

const RejectDialog: React.FC<RejectDialogProps> = ({
  orgId,
  applicationId,
  onClose,
}) => {
  const dispatch = useDispatch();
  const { control, errors, handleSubmit } = useForm({
    defaultValues: { rejectReasons: [] } as RejectApplication,
  });

  const onSubmit = (model: RejectApplication) => {
    const listMeta = buildMetaData(
      model,
      {} as RejectApplication,
      ["rejectReasons"],
      lookupTracker
    );
    const meta = listMeta.map((item: ChangeMeta) => {
      return {
        newValue: item.newValue.toString(),
        oldValue: item.oldValue.toString(),
        field: item.field,
      };
    });
    dispatch(rejectApplication(orgId, applicationId, { model, meta }));
    onClose();
  };

  const [lookups] = useLookup(applicationRejectReasonService);
  const lookupTracker = useMemo(() => getLookupTracker(), []);

  return (
    <>
      <Dialog open={true} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Reject this Application?</DialogTitle>
        <Divider component="div" />
        <DialogContent>
          <form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Controller
                  name="rejectReasons"
                  data-test="reject-reason"
                  rules={{
                    required: true,
                  }}
                  control={control}
                  as={
                    <Select
                      label="Reason"
                      lookupTracker={lookupTracker}
                      selectVariant={"multiple"}
                    >
                      {lookups}
                    </Select>
                  }
                />
                {errors.rejectReasons && <Error>This field is required</Error>}
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
          <Button data-test="reject-confirm" onClick={handleSubmit(onSubmit)} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
